/**
 * @fileoverview A titled panel of the Active Client details.
 * @description A section heading above a two-column grid of fields, shared by the profile panels
 * and the HR Admin block.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import DetailSectionHeading from '@/shared/components/molecules/DetailSectionHeading'

import type { ReactNode } from 'react'

/**
 * @component
 * @param {{ title: string; testId: string; children: ReactNode }} props - The panel's content.
 * @param {string} props.title - The section's title.
 * @param {string} props.testId - QA locator for the panel.
 * @param {ReactNode} props.children - The panel's fields.
 */
function ClientPanel({
  title,
  testId,
  children,
}: {
  title: string
  testId: string
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-2.5" data-testid={testId}>
      <DetailSectionHeading>{title}</DetailSectionHeading>
      <div className="grid grid-cols-1 gap-3.5 rounded-lg border border-row-border bg-surface-hover p-4 sm:grid-cols-2">
        {children}
      </div>
    </div>
  )
}

export default ClientPanel
